<template>
    <div v-show="visible" ref="resizeHandle" class="card card-resizable-top fixed-bottom" @mousedown="startDrag" @mousemove="onDrag">
        <div class="card-body m-0 p-0">
            <div class="d-flex justify-content-between justify-content-center border-bottom mb-2 p-1 bg-dark text-white">
                <div class="h5 font-weigh-bold my-auto ml-2">Output Messages</div>
                <div class="mr-2">
                    <button class="btn btn-sm btn-secondary" @click="close()">Close</button>
                </div>                
            </div>
            <div id="output" class="output-messages ml-2">
                <div v-for="(message, index) in messages" :key="'output-frame-' + index" v-html="message"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        outputMessages: [Array, null]
    },
    data() {
        return {
            visible: (this.outputMessages && (this.outputMessages.length > 0)),
            messages: this.outputMessages ? this.outputMessages : [],
            dragging: false,
            resizeHandle: null,
            pos: null
        }
    },
    created() {
        var self = this;
        window.Echo.private('output-frame.' + window.Laravel.user)
            .listen('OutputEvent', (e) => {
                self.visible = true;
                self.messages.push(e.message);
                var container = this.$el.querySelector("#output");
                container.scrollTop = container.scrollHeight;
        });
    },
    mounted() {
        this.resizeHandle = this.$refs.resizeHandle;
        window.addEventListener('mouseup', this.stopDrag);
    },
    methods: {
        close: function () {
            this.visible = false;
            this.messages = [];
            axios.delete('/ajax/output')
                .then(response => {
                    // nothing to do for now
                })
                .catch(error => {
                    // nothing to do for now
                });
        },
        resize: function (e) {
            const dy = this.pos - e.y;
            this.pos = e.y;
            this.resizeHandle.style.height = (parseInt(getComputedStyle(this.resizeHandle, '').height) + dy) + "px";
            this.$forceUpdate();
        },
        startDrag: function (e) {
            if (e.offsetY < 5) {
                this.pos = e.y;
                document.body.style.cursor = 'ns-resize';
                this.dragging = true;
            }
        },
        onDrag: function (e) {
            if (this.dragging) {
                this.resize(e);
            }
        },
        stopDrag: function (e) {
            if (this.dragging) {
                this.resize(e);
                this.pos = null;
                document.body.style.cursor = 'initial';
                this.dragging = false;
            }
        }
    }
}
</script>

<style scoped>
    .card-resizable-top {
        overflow: hidden;
        max-height: 75%;
    }

    .card-resizable-top::before {
        content: '';
        background-color: transparent;
        width: 100%;
        height: 5px;
        cursor: ns-resize;
        background-color: #343a40 !important;
    }    

    .card-body { 
        padding: 0;    
    }

    .output-messages {
        height: 90%;
        overflow: auto !important;
    }
    
</style>